import React, { useEffect, useState } from 'react';
import mobiscroll from '@mobiscroll/react'
import { styleNumber, numberWithCommas, exportToCsv, isSupportFn } from '../Helper';


const RecordRow = React.memo(({ item }) => {
    const d = item
    if (d._id === 'total') {
        const total = styleNumber(d.total)
        return (
            <li key={d._id}>
                累積損益
                <span className={'mx-2 ' + total.color}>{total.number}</span>
            </li>
        )
    } else if (d.year && !d.month) {
        const total = styleNumber(d.total)
        return (
            <li key={d._id}>
                <span style={{ fontWeight: 'bold' }}>{d.year}年 </span>
                已實現損益
                <span className={'mx-2 ' + total.color}>{total.number}</span>
            </li>
        )
    } else if (d.month) {
        return (
            <li key={d._id}>
                <span style={{ fontWeight: 'bold' }}>{d.month}月 </span>
                實際
                <span className="mx-1">收入 {numberWithCommas(d.income)}</span>
                <span className="mx-1">支出 {numberWithCommas(d.expense)}</span>
                <span className="float-right">
                    <i className={d.open ? 'bi bi-chevron-up' : 'bi bi-chevron-down'}></i>
                </span>
            </li>
        )
    } else {
        let action = ''
        let amount = ''
        let fee = d.cfee ? d.cfee : d.cfee === 0 ? 0 : d.fee
        let credit = ''
        if (d.credit)
            credit = d.creditType === 'short' ? '券' : '資'
        switch (d.action) {
            case 'sell':
                action = <span className="text-success mx-1">{credit}賣</span>
                amount = <span className="text-success mx-1">收入 {numberWithCommas(d.amount - fee)}</span>
                break;
            case 'profit':
                const profitTxt = {
                    profit: "股利",
                    reduction: "減資",
                    lending: "借券",
                }[d.profitType] || "股利";
                action = <span className="text-primary mx-1">{profitTxt}</span>
                amount = <span className="text-primary mx-1">收入 {numberWithCommas(d.amount)}</span>
                break;
            default:
                action = <span className="text-danger mx-1">{credit}買</span>
                amount = <span className="text-danger mx-1">支出 {numberWithCommas(d.amount + fee)}</span>
                break;
        }
        return (
            <li key={d._id}>
                {d.date.substring(5)}
                {action}
                {d.name}
                <span className="mx-1 ">{d.quantity} 股</span>
                <span className="mx-1 ">價格 {d.price}</span>
                {amount}
            </li>
        )
    }

})

export const RecordList = ({ data, handler }) => {

    const [open, setOpen] = useState(null)
    const [displayData, setDisplayData] = useState(data.filter(d => !d.action))

    const { setTransaction } = handler

    const onItemTap = (ev) => {
        if (displayData[ev.index]._id !== 'total' && !displayData[ev.index].year && !displayData[ev.index].month) {
            setTransaction(displayData[ev.index])
        } else {
            if (displayData[ev.index].month) {
                const clickYearMon = displayData[ev.index].year + '-' + displayData[ev.index].month
                if (clickYearMon !== open) {
                    setOpen(clickYearMon)
                } else {
                    setOpen(null)
                }
            }
        }
    }

    useEffect(() => {
        if (open) {
            setDisplayData(data.map(d => (d.year + '-' + d.month === open ? { ...d, open: true } : d)).filter(d => !d.action || d.date.startsWith(open)))
        } else {
            setDisplayData(data.filter(d => !d.action))
        }
    }, [data, open])

    return (
        <mobiscroll.Listview
            itemType={RecordRow}
            dataKeyField="_id"
            data={displayData}
            className="md-list-cont"
            swipe={false}
            striped={true}
            enhance={true}
            onItemTap={onItemTap}
            animateAddRemove={false}
            actionable={false}
        />
    )
}

class Record extends React.Component {

    constructor(props) {
        super(props);
        const { categories, yearData } = this.grouped(props.data)
        this.state = {
            categories,
            yearData,
            selectedCategory: categories[0]
        };
        this.navRef = null;
        this.viewRef = null;
    }

    grouped = (data) => {
        let categories = []
        let yearData = {}
        let monData = { _id: '', year: '', month: '', expense: 0, income: 0 }
        let monIdx = 0
        data.forEach((d) => {
            const date = d.date.split('-')
            const y = date[0]
            const m = date[1]
            if (categories.indexOf(y) === -1) {
                categories.push(y)
                yearData[y] = [d]
            } else {
                yearData[y].push(d)
            }

            if (monData.month !== m || monData.year !== y) {
                if (monData.month !== '') {
                    yearData[monData.year].splice(monIdx, 0, { ...monData })
                    monIdx = monData.year !== y ? 0 : yearData[monData.year].length - 1
                }
                monData = { _id: y + m, year: y, month: m, expense: 0, income: 0 }
            }
            let fee = d.cfee ? d.cfee : d.cfee === 0 ? 0 : d.fee
            if (d.action === 'buy') {
                monData.expense += (d.amount + fee)
            } else {
                monData.income += (d.amount - fee)
            }
        })
        if (monData.month !== '') {
            yearData[monData.year].splice(monIdx, 0, { ...monData })
        }
        return { categories, yearData }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            const { categories, yearData } = this.grouped(this.props.data)
            this.setState({ categories, yearData })
        }
    }

    setCategory = (year) => {
        this.setState({
            selectedCategory: year
        })
    }

    onAnimationStart = (event, inst) => {
        const selectedIndex = parseInt((-(event.destinationX / inst.contWidth)).toString(), 10);
        const selectedCategory = this.state.categories[selectedIndex];

        if (selectedCategory !== this.state.selectedCategory) {
            this.setState({ selectedCategory: selectedCategory });
        }
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        if (nextState.selectedCategory !== this.state.selectedCategory) {
            this.viewRef.instance.navigate(nextState.selectedCategory);
            return false;
        }
        return true;
    }

    genCsvRow = (d) => {
        const profitTxt = {
            profit: "股利",
            reduction: "減資",
            lending: "借券",
        }[d.profitType] || "股利";
        const action = d.action === 'sell' ? '賣' : d.action === 'buy' ? '買' : profitTxt
        return `${d.date},${d.id},${d.name},${action},${d.quantity},${d.price},${d.amount}`
    }

    exportCSV = (ev) => {
        const { selectedCategory } = this.state
        const rows = this.state.yearData[selectedCategory].filter(d => d.date)
            .map(d => this.genCsvRow(d).split(','))
        rows.splice(0, 0, ['日期', '代號', '名稱', '類型', '股數', '價格', '金額'])
        exportToCsv('stockbook-export.csv', rows)
        console.log(ev)

    }


    render() {

        const { categories, yearData, selectedCategory } = this.state
        const { theme } = this.props
        const btnCls = theme === 'dark' ? 'light' : 'dark';

        return (
            <div style={{ height: '100%' }}>
                {(isSupportFn('convertBase64StringToCsvAndStoreIt') || true) &&
                    <div className="d-flex justify-content-end mr-4">
                        <button className={'mb-2 rounded-bottom border border-0 bg-' + theme} onClick={this.exportCSV} >
                            <i className={'bi bi-download text-' + btnCls} />
                        </button>
                    </div>}
                <mobiscroll.TabNav ref={el => { this.navRef = el }} display="inline">
                    {categories.map((year) => {
                        return <mobiscroll.NavItem key={year}
                            id={year}
                            selected={year === selectedCategory}
                            onClick={this.setCategory.bind(this, year)}
                        >
                            {year}
                        </mobiscroll.NavItem>
                    })}
                </mobiscroll.TabNav>
                <div className="md-paging">
                    <mobiscroll.ScrollView
                        ref={el => { this.viewRef = el }}
                        layout={1}
                        paging={true}
                        threshold={15}
                        cssClass="md-page"
                        onAnimationStart={this.onAnimationStart}
                    >
                        {categories.map((year) =>
                            <div key={year} data-id={year}>
                                <RecordList key={year} data={yearData[year]} handler={this.props.handler} />
                            </div>
                        )}
                    </mobiscroll.ScrollView>
                </div>
            </div>
        );
    }
}

export default Record